import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import MY_CONFIG from '@/constants';
import { useLang } from "../../context/TranslationProvider";
import LanguageDropdown from "@/components/LanguageSwitcher";


import {
  FiMenu,
  FiPackage,
} from "react-icons/fi";

import {
  AiOutlineLogin,
} from "react-icons/ai";

import {
  FaHome,
  FaShip,
} from "react-icons/fa";


import {
  MdTravelExplore,
} from "react-icons/md";
import CustomSidebarButton from "@/components/CustomSidebarButton";
import AppSidebar from "@/components/MySidebar";
import DarkModeToggle from "@/components/DarkModeToggle";
import ProfileMenu from "@/components/ProfileMenu";



// ======================================
// COMPONENT
// ======================================

export default function MyNavbar() {
  const { t, direction } = useLang();
  const { user, logout } = useAuth();

  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50">
      {/* BACKDROP */}
      <div className="absolute inset-0 bg-white/70 dark:bg-gray-900/70 backdrop-blur-2xl border-b border-white/20 dark:border-gray-800 shadow-lg" />

      {/* CONTENT */}
      <div className="relative max-w-7xl mx-auto px-3 sm:px-6">
        <div className="h-16 flex items-center justify-between gap-3">
          {/* ======================================
              LEFT
          ====================================== */}

          <div className="flex items-center gap-2 lg:gap-3">
            {/* MOBILE SIDEBAR */}
            <div className="lg:hidden">
              <CustomSidebarButton
                button={
                  <div className="w-11 h-11 rounded-2xl bg-white dark:bg-gray-800 shadow flex items-center justify-center">
                    <FiMenu size={22} />
                  </div>
                }
                side={
                  direction === "rtl"
                    ? "right"
                    : "left"
                }
                sidebarContent={<AppSidebar />}
              />
            </div>

            {/* LOGO */}
            <Link
              to="/"
              className="flex items-center gap-3"
            >
              <div className="w-11 h-11 rounded-2xl overflow-hidden shadow-md bg-white dark:bg-gray-800">
                <img
                  src={MY_CONFIG.ICON_URL}
                  alt="Logo"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="hidden sm:block">
                <div className="font-black text-lg leading-tight dark:text-white">
                  {t("site_official_name")}
                </div>

                <div className="text-xs text-gray-500 dark:text-gray-400">
                  Maldives Experiences
                </div>
              </div>
            </Link>
          </div>

          {/* ======================================
              CENTER NAVIGATION
          ====================================== */}

          <div className="hidden lg:flex items-center gap-2">
            <NavItem
              to="/"
              icon={<FaHome />}
              label="Home"
            />

            <NavItem
              to="/products"
              icon={<MdTravelExplore />}
              label="Products"
            />

            <NavItem
              to="/packages"
              icon={<FiPackage />}
              label="Packages"
            />

            <NavItem
              to="/trips"
              icon={<FaShip />}
              label="Trips"
            />
          </div>

          {/* ======================================
              RIGHT
          ====================================== */}

          <div className="flex items-center gap-2 lg:gap-3">
            {/* DARK MODE */}
            <div className="hidden sm:block">
              <DarkModeToggle />
            </div>

            {/* LANGUAGE */}
            <div className="hidden sm:block">
              <LanguageDropdown />
            </div>

       

            {/* PROFILE / LOGIN */}
            {user ? (
              <div className="ml-1">
                <ProfileMenu
                  user={user}
                  logout={handleLogout}
                  avatarUrl={MY_CONFIG.ICON_URL}
                />
              </div>
            ) : (
              <Link
                to="/login"
                className="
                  flex items-center gap-2
                  bg-black dark:bg-white
                  text-white dark:text-black
                  px-4 py-2.5
                  rounded-2xl
                  font-medium
                  shadow-lg
                  hover:scale-105
                  transition
                "
              >
                <AiOutlineLogin size={20} />

                <span className="hidden sm:block">
                  Login
                </span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

// ======================================
// NAV ITEM
// ======================================

function NavItem({
  to,
  icon,
  label,
}: {
  to: string;
  icon: React.ReactNode;
  label: string;
}) {
  return (
    <Link
      to={to}
      className="
        flex items-center gap-2
        px-4 py-2.5
        rounded-2xl
        text-gray-700 dark:text-gray-200
        hover:bg-white dark:hover:bg-gray-800
        hover:shadow-md
        transition-all
        duration-200
        font-medium
      "
    >
      <span className="text-lg">
        {icon}
      </span>

      <span>{label}</span>
    </Link>
  );
}